import React, {useRef, useEffect} from "react";
import styles from "./styles.css";
import { NUMBER } from "../../../constants/app-constants";
import { PropTypes } from "prop-types";

const GuageChart = ({ percentage = NUMBER.FIFTY }) => {
    const blueRef = useRef(null);

    useEffect(() => {
        if (blueRef.current) {
            const strokeOffest = NUMBER.THREE_HUNDERED_THIRTY - ((percentage / NUMBER.HUNDRED) * NUMBER.THREE_HUNDERED_THIRTY);
            blueRef.current.style.strokeDashoffset = strokeOffest;
            blueRef.current.style.transition = "stroke-dashoffset 1s ease-out";
        }
    }, [percentage]);

    return (
        <div styleName={"styles.estimatedRepyamentProgresBarCustomSVG"}>
            <svg viewBox="-15 0 265 115" height="120" width="245">
                <linearGradient id="gradient" x1="0" y1="0" x2="0" y2="100%">
                    <stop offset="0%" stopColor="#0066CC" />
                    <stop offset="100%" stopColor="#0066CC" />
                </linearGradient>

                <filter
                    id="filter0_i_1707_62618"
                    x="-10"
                    y="0"
                    width="265"
                    height="130"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="-4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1707_62618" />
                </filter>

                <g  filter="url(#filter0_i_1707_62618)">
                    <path class="grey" styleName={"styles.grey"} d="M0,115 A115,115 0 0,1 228,115" fill="none" />
                </g>

                <path ref={blueRef} id="blue" class="blue" fill="none" styleName={"styles.blue"} d="M0,115 A115,115 0 0,1 228,115" />
            </svg>
        </div>
    );
};

GuageChart.propTypes = {
    percentage: PropTypes.number
};

export default GuageChart;
